module.exports = __webpack_public_path__ + "img/map-white.cf502fc9.svg";